import { useMemo } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

import RingLoader from 'react-spinners/RingLoader';

export const MapContainer = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const center = useMemo(() => ({ lat: 51.531923, lng: -0.123413 }), []);
  const shopPosition = useMemo(() => ({ lat: 51.53231966914941, lng: -0.12349066002663271 }), []);

  return isLoaded ? (
    <GoogleMap zoom={16} center={center} mapContainerClassName="w-3/4 h-2/4 md:w-3/5 xl:h-3/5">
      <Marker position={shopPosition} />
    </GoogleMap>
  ) : (
    <RingLoader color={'#F4F4F4'} loading={isLoaded} size={120} />
  );
};
